export const cornflowerBlue = "#4385F5";
export const persianPink = "#FC74A4";
export const crimson = "#A51C30";
export const gray = "#CCCCCC";